/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from '@reduxjs/toolkit';
import { InjectedReducersType } from '../../utils/types/injector-typings';
import { slice as leagueSlice } from '../slice';
import { api } from '../api';

const createReducer = (injectedReducers: InjectedReducersType = {}) => {
  return combineReducers({
    league: leagueSlice.reducer,
    [api.reducerPath]: api.reducer,
    ...injectedReducers,
  });
};

export default createReducer;
